import { BP42Action } from '@r1-frontend/bp42/constants/actions';

import { IAction } from '@r1-frontend/shared/types/Redux';

const showPopup = (): IAction<BP42Action.OpenPopup, null> => ({
    type: BP42Action.OpenPopup,
    payload: null,
});

export default showPopup;
